import { emptyList, emptyObject } from '@constants/empty';
import {
  getDateKey,
  getTodayDate
} from '@cont/Planner/planner-utils/date-time-helper';

const emptyDataObject = {
  plannerItemsByDays: emptyObject,
  datesAndKeys: emptyList,
  todayIndex: -1,
  todayOffset: 0,
  initialDateIndex: -1,
  initialDateOffset: 0
};

const getExtraBlockInfo = (state, goalUID, dateKey) =>
  state.plannerExtraInfo?.[goalUID]?.[dateKey] || emptyObject;

const getPlannerHelperFlagsInfo = (state, goalUID) =>
  state.plannerHelperFlags?.[goalUID] || emptyObject;

const getPlannerHelperFlagsInfoV2 = (state) =>
  state.plannerHelperFlags || emptyObject;

// Calendar Store
export const getCalendarDate = (goalUID) => (state) =>
  state.calendarCurrentDate[goalUID] || null;

export const getCalendarDateV2 = () => (state) =>
  state.calendarCurrentDate || null;

export const getCalendarDateSetter = (state) => state.setCurrentDate;

export const getCalendarDateSetterV2 = (state) => state.setCurrentDate;

// Feature Cards Store
export const getFeatureCards =
  (goalUID, dateKey = getDateKey(getTodayDate().date)) =>
  (state) =>
    getExtraBlockInfo(state, goalUID, dateKey).featureCards || [];

export const getFeatureCardsSetter = (state) => state.setFeatureCards;

export const getUpsellCards =
  (goalUID, dateKey = getDateKey(getTodayDate().date)) =>
  (state) =>
    getExtraBlockInfo(state, goalUID, dateKey).upsellCards || [];

export const getUpsellCardsSetter = (state) => state.setUpsellCards;

// Browse / Greetings Card Store
export const getShowBrowse =
  (goalUID, dateKey = getDateKey(getTodayDate().date)) =>
  (state) =>
    getExtraBlockInfo(state, goalUID, dateKey).showBrowse || false;

export const getShowBrowseSetter = (state) => state.setShowBrowse;

// Helper Flags Store
export const getIsFirstRun = (goalUID) => (state) =>
  getPlannerHelperFlagsInfo(state, goalUID).isFirstRun || false;

export const getIsInitialSetupComplete = (goalUID) => (state) =>
  getPlannerHelperFlagsInfo(state, goalUID).isInitialSetupComplete || false;

export const getIsFinalSetupComplete = (goalUID) => (state) =>
  getPlannerHelperFlagsInfo(state, goalUID).isFinalSetupComplete || false;

export const getIsFinalSetupCompleteV2 = () => (state) =>
  getPlannerHelperFlagsInfoV2(state).isFinalSetupComplete || false;

export const getIsEveryTimeTasksSetupComplete = (goalUID) => (state) =>
  getPlannerHelperFlagsInfo(state, goalUID).isEveryTimeTasksSetupComplete ||
  false;

export const getIsFirstRunSetter = (state) => state.setIsFirstRun;

export const getIsInitialSetupCompleteSetter = (state) =>
  state.setIsInitialSetupComplete;

export const getIsFinalSetupCompleteSetter = (state) =>
  state.setIsFinalSetupComplete;

export const getIsFinalSetupCompleteSetterV2 = (state) =>
  state.setIsFinalSetupComplete;

export const getIsEveryTimeTasksSetupCompleteSetter = (state) =>
  state.setIsEveryTimeTasksSetupComplete;

// Planner Info Store
export const getData = (goalUID) => (state) =>
  state.plannerInfo?.[goalUID] || emptyDataObject;

export const getItemUpdateInfo = (goalUID) => (state) =>
  state.plannerInfo?.[goalUID]?.itemUpdateInfo;

export const getDataSetter = (state) => state.setPlannerInfo;

// Planner Info Store V2
export const getDataV2 = () => (state) => state.plannerInfo;

export const getDataSetterV2 = (state) => state.setPlannerInfo;

// Planner Events Store
export const getGoalEventsData = (goalUID) => (state) =>
  state.plannerEventsData?.[goalUID] || emptyObject;

export const getEventData = (eventUID, goalUID) => (state) =>
  state.plannerEventsData?.[goalUID]?.[eventUID] || null;

export const getEventDataSetter = (state) => state.setPlannerEventsData;

export const getMultipleEventDataSetter = (state) =>
  state.setPlannerMultipleEventsData;

export const getEventsDataResetter = (state) => state.resetEventsData;

// LMP Store
export const getLMPCancelledSession = (goalUID, sessionUID) => (state) =>
  state.lmpPlannerCancelledSession?.[goalUID]?.[sessionUID] || emptyObject;

export const cancelPlannerLmp = (state) => state.cancelPlannerLmpSession;
